import React, { useEffect, useMemo } from "react";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import { getUid } from "../../api/auth";

import ChatBox from "../chat-box";
import NoFoundMessage from "../not-found-message";

import StyledChatList from "./styles";

const ChatList = ({ messages, name }) => {
  const noMessages = !messages || messages.length === 0;
  const { uid } = useMemo(() => getUid(), []);

  return (
    <StyledChatList>
      <div className="chat-list">
        {noMessages ? (
          <div className="chat-list-fallback">
            <NoFoundMessage
              icon={<BeachAccessIcon />}
              message={`Inicia una conversación ${name ? `con ${name}` : ""} `}
            />
          </div>
        ) : (
          messages.map((message) => (
            <ChatBox
              content={message.content}
              inverted={message.from === uid}
              timestamp={message.timestamp}
              type={message.type}
              color={message.from === uid ? "" : "#0084FF"}
              horizontal={message.horizontal}
            />
          ))
        )}
      </div>
    </StyledChatList>
  );
};

export default ChatList;
